import get from 'lodash/get'
import { COUNTRY_CODES_BY_ZUORA_COUNTRY } from '../common/regionUtils.js'
import { translate } from '../plugins/i18n'

import { payMethodIconMap } from '../common/constant'
import VisaIcon from '../assets/Visa.svg'
import MasterCardIcon from '../assets/MasterCard.svg'
import JCBIcon from '../assets/JCB.png'
import DiscoverIcon from '../assets/Discover.svg'
import AmexIcon from '../assets/Amex.svg'

export const APM_PAYMENT_METHODS = {
  SOFORT: 'sofort',
  IDEAL: 'ideal',
  FURIKOMI: 'customer_balance',
  US_ACH_ONLINE: 'us_bank_account',
  WISE: 'wise',
  KLARNA: 'klarna',
  P24: 'p24'
}

export const getWisePaymentName = (imageFileName) => {
  const wiseSubstr = `${APM_PAYMENT_METHODS.WISE}-`
  return imageFileName.substring(imageFileName.indexOf(wiseSubstr) + wiseSubstr.length).toLowerCase()
}

export const getAPMPaymentCardLabel = (apmPaymentMethodName, billingInfo) => {
  const apmDetails = JSON.parse(get(billingInfo, 'externalApmPaymentDetails'))
  if (apmPaymentMethodName === APM_PAYMENT_METHODS.KLARNA) {
    return translate(`billing.payment.klarna_payment_catgory.${apmDetails.payment_method_category}`)
  } else if (apmPaymentMethodName === APM_PAYMENT_METHODS.WISE) {
    return translate(`billing.payment.wise_plus_${getWisePaymentName(apmDetails.wise)}`)
  }
  const apmCountryCode = apmDetails.country || COUNTRY_CODES_BY_ZUORA_COUNTRY[billingInfo?.soldToContact?.country]
  const lastFour = apmDetails.iban_last4 || apmDetails.account_last4?.substring(8, 12)
  return lastFour ? `${apmCountryCode}********${lastFour}` : translate(`billing.payment.${apmPaymentMethodName}`)
}

export const getCreditCardIcon = (creditCardType) => {
  switch (creditCardType) {
    case 'Visa':
      return VisaIcon
    case 'MasterCard':
      return MasterCardIcon
    case 'Discover':
      return DiscoverIcon
    case 'AmericanExpress':
      return AmexIcon
    case 'JCB':
      return JCBIcon
    default:
      return payMethodIconMap.CreditCard
  }
}
